module.exports = __webpack_public_path__ + "img/category_kjyouyou.52ab6034.jpg";